import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SupplierNavbar from "./SuppplierNavbar";
import SupplierSidebar from "./SupplierSidebar";
import Axios from "../../../axios/axios";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./Supplier.css";
import { useLocation } from 'react-router-dom';

function SupplierReturns() {
  const [supplier, setSupplier] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [returns, setReturns] = useState([]);
  const location = useLocation();

useEffect(() => {
  if (window.innerWidth < 768) {
    setSidebarOpen(false);
  }
}, [location]);

  
  const [topReturnedProducts, setTopReturnedProducts] = useState([]);


 useEffect(() => {
  const storedSupplier = sessionStorage.getItem("supplierInfo");
  if (storedSupplier) {
    const supplierInfo = JSON.parse(storedSupplier);
    setSupplier(supplierInfo);

    Axios.get(`/returns/supplier/${supplierInfo.supplierId}`)
      .then((res) => {
        // Sort returns by newest first
        const sortedReturns = res.data.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
        setReturns(sortedReturns);
      })
      .catch((err) => console.error("Error fetching returns:", err));

      Axios.get(`/returns/top/${supplierInfo.supplierId}`)
  .then((res) => {
    setTopReturnedProducts(res.data);
  })
  .catch((err) => console.error("Error fetching top returned products:", err));

  }

  
}, []);
function getProductNameFromOrder(item) {
  if (!item?.orderId?.orderItems) return null;
  const match = item.orderId.orderItems.find(
    (oi) => oi.name?.toLowerCase() === item.name?.toLowerCase()
  );
  return match?.name || null;
}


  return (
    <div className="enhanced-body">
      <SupplierNavbar
        supplier={supplier}
        setSupplier={setSupplier}
        toggleSidebar={() => setSidebarOpen(!sidebarOpen)}
      />

      <div className="container-fluid">
        <div className="row">
          {sidebarOpen && (
            <div className="col-md-2">
                                           <SupplierSidebar closeSidebar={() => {
              if (window.innerWidth < 768) setSidebarOpen(false);
            }} />
            </div>
          )}

          <div className={sidebarOpen ? "col-md-10" : "col-md-12"}>
            <div className="dashboard-main">
              <h2 className="dashboard-title mb-4">Returned Products</h2>

              <div className="table-responsive shadow rounded bg-white p-3">
                <table className="table table-hover">
                  <thead className="table-secondary">
                    <tr>
                      <th>Product Name</th>
                      <th>Returned Date</th>
                      <th>Customer Name</th>
                      <th>Reason</th>
                    </tr>
                  </thead>
   <tbody>
  {returns.length > 0 ? (
    returns.map((item, idx) => (
      <tr key={idx}>
        <td>
          {item.productId?.name ||
           getProductNameFromOrder(item) ||
           item.name || "N/A"}
        </td>
        <td>{new Date(item.createdAt).toLocaleDateString()}</td>
        {/* <td>{item.customerId?.customerName || "N/A"}</td> */}
        <td>Asiapart Customer {idx + 1}</td>
        <td>{item.description}</td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="4" className="text-center text-muted">
        No returns available
      </td>
    </tr>
  )}
</tbody>


                </table>
              </div>
              {/* Most Returned Product Card - UI Only */}
             {topReturnedProducts.length > 0 && (
  <div className="card mt-4 shadow-sm p-3 bg-light">
    <h5 className="mb-3">Top 3 Most Returned Products</h5>
    {topReturnedProducts.map((prod, index) => (
      <div key={index} className="d-flex align-items-center mb-2">
        <div className="me-3">
          <i className="bi bi-arrow-repeat fs-4 text-danger"></i>
        </div>
        <div>
          <strong>{prod.name || "Unknown Product"}</strong>
          <div className="text-muted">Returned {prod.count} times</div>
        </div>
      </div>
    ))}
  </div>
)}

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SupplierReturns;
